import BottomNavigation from '@/components/BottomNavigation';
import Category from '@/components/Category/CategoryHolder';
import ContentWrapper from '@/components/ContentWrapper';
import CopyParagraph from '@/components/Copy/CopyParagraph';
import GameDetailsModal from '@/components/GameDetailsModal';
import JackpotBetWidget from '@/components/JackpotBetWidget';
import Layout from '@/components/Layout';
import Modal from '@/components/Modal';
import PromotionsBasecamp from '@/components/PromotionsBasecamp';
import SearchBar from '@/components/SearchBar';
import SearchInput from '@/components/SearchInput';
import SearchModal from '@/components/SearchModal';

import loaders from './loaders';

const LiveGamesContent = loaders.lazy(() =>
  import(
    /* webpackChunkName: "LiveGamesContent" */ '../../components/LiveGamesContent'
  )
);

const CategoryDetails = loaders.lazy(() =>
  import(
    /* webpackChunkName: "CategoryDetails" */ '../../components/Category/CategoryDetails'
  )
);

const Header = loaders.lazy(() =>
  import(/* webpackChunkName: "Header" */ '../../components/Header')
);

const MainNavigation = loaders.lazy(() =>
  import(/* webpackChunkName: "MainNavigation" */ '@/components/MainNavigation')
);
const GameDetailsHeader = loaders.lazy(() =>
  import(
    /* webpackChunkName: "GameDetailsHeader" */ '../../components/GameDetailsHeader'
  )
);
const BingoGames = loaders.lazy(() =>
  import(/* webpackChunkName: "BingoGames" */ '../../components/BingoGames')
);
const GameDetails = loaders.lazy(() =>
  import(/* webpackChunkName: "GameDetails" */ '../../components/GameDetails')
);
const GameDetailsContent = loaders.lazy(() =>
  import(
    /* webpackChunkName: "GameDetailsContent" */ '../../components/GameDetailsContent'
  )
);
const SearchCategory = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchCategory" */ '../../components/SearchCategory'
  )
);
const SearchMoreResults = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchMoreResults" */ '../../components/Category'
  )
);
const SimplifiedHeader = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SimplifiedHeader" */ '../../components/SimplifiedHeader'
  )
);
const SearchHeader = loaders.lazy(() =>
  import(/* webpackChunkName: "SearchHeader" */ '../../components/SearchHeader')
);
const SearchHistory = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchHistory" */ '../../components/SearchHistory'
  )
);
const ErrorPage = loaders.lazy(() =>
  import(/* webpackChunkName: "ErrorPage" */ '../../components/ErrorPage')
);
const GameModal = loaders.lazy(() =>
  import(/* webpackChunkName: "GameModal" */ '../../components/GameModal')
);
const Copy = loaders.lazy(() =>
  import(/* webpackChunkName: "Copy" */ '../../components/Copy')
);
const FloatingIcon = loaders.lazy(() =>
  import(/* webpackChunkName: "FloatingIcon" */ '../../components/FloatingIcon')
);
const ErrorContainer = loaders.lazy(() =>
  import(
    /* webpackChunkName: "ErrorContainer" */ '../../components/ErrorContainer'
  )
);
const CookieBanner = loaders.lazy(() =>
  import(/* webpackChunkName: "CookieBanner" */ '../../components/CookieBanner')
);
const Menu = loaders.lazy(() =>
  import(/* webpackChunkName: "Menu" */ '../../components/Menu')
);
const SearchWrapper = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchWrapper" */ '../../components/SearchWrapper'
  )
);
const Download = loaders.lazy(() =>
  import(/* webpackChunkName: "Download" */ '../../components/DownloadPage')
);
const SearchSuggestions = loaders.lazy(() =>
  import(
    /* webpackChunkName: "SearchSuggestions" */ '../../components/SearchSuggestions'
  )
);
const Steps = loaders.lazy(() =>
  import(/* webpackChunkName: "Steps" */ '../../components/Steps')
);
const BannerStandalone = loaders.lazy(() =>
  import(
    /* webpackChunkName: "BannerStandalone" */ '../../components/BannerStandalone'
  )
);
const VideoModal = loaders.lazy(() =>
  import(/* webpackChunkName: "VideoModal" */ '../../components/VideoModal')
);
const ProvidersFilter = loaders.lazy(() =>
  import(
    /* webpackChunkName: "ProvidersFilter" */ '../../components/ProvidersFilter'
  )
);
const IdlePopup = loaders.lazy(() =>
  import(/* webpackChunkName: "IdlePopup" */ '../../components/IdlePopup')
);

const JackpotDrawer = loaders.lazy(() =>
  import(/* webpackChunkName: "JackpotDrawer" */ '../../components/JackpotDrawer')
);
const JackpotWidget = loaders.lazy(() =>
  import(
    /* webpackChunkName: "JackpotWidget" */ '../../components/JackpotWidget'
  )
);

const SearchRecentlyPlayed = loaders.lazy(() =>
  import(
    /* webpackChunkName: "IdlePopup" */ '../../components/SearchRecentlyPlayed'
  )
);

const componentMapping = {
  LiveGamesContent,
  Layout,
  MainNavigation,
  Category,
  CategoryDetails,
  RecentlyPlayed: Category,
  ContentWrapper,
  BottomNavigation,
  SearchInput,
  CopyParagraph,
  Header,
  GameDetailsHeader,
  BingoGames,
  GameDetails,
  GameDetailsContent,
  SearchBar,
  SearchCategory,
  SearchMoreResults,
  SimplifiedHeader,
  SearchHeader,
  SearchHistory,
  SearchRecentlyPlayed,
  ErrorPage,
  Modal,
  GameModal,
  GameDetailsModal,
  PromotionsBasecamp,
  Copy,
  FloatingIcon,
  ErrorContainer,
  CookieBanner,
  Menu,
  SearchWrapper,
  Download,
  SearchSuggestions,
  Steps,
  BannerStandalone,
  VideoModal,
  ProvidersFilter,
  IdlePopup,
  JackpotBetWidget,
  JackpotDrawer,
  JackpotWidget,
  SearchModal,
};

export default componentMapping;
